import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { user, girisYap, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [sifreGoster, setSifreGoster] = useState(false);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  if (!loading && user) return <Navigate to="/" replace />;

  async function handleSubmit(e) {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);
    const { error } = await girisYap(email, sifre);
    if (error) setHata('E-posta veya şifre hatalı.');
    setYukleniyor(false);
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', padding: '10px 20px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, marginBottom: 16 }}>
            <img src="/logo.svg" alt="PisiPro" style={{ height: 36 }} />
          </div>
        </div>
        <div className="card" style={{ padding: 28 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24 }}>Giriş Yap</h2>
          {hata && <div className="alert alert-error">{hata}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">E-posta</label>
              <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ornek@email.com" autoComplete="email" autoFocus required />
            </div>
            <div className="form-group">
              <label className="label">Şifre</label>
              <div style={{ position: 'relative' }}>
                <input className="input" type={sifreGoster ? 'text' : 'password'} value={sifre} onChange={e => setSifre(e.target.value)} placeholder="••••••••" autoComplete="current-password" required style={{ paddingRight: 44 }} />
                <button type="button" onClick={() => setSifreGoster(!sifreGoster)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text2)', fontSize: 18 }}>
                  {sifreGoster ? '🙈' : '👁️'}
                </button>
              </div>
            </div>
            <button className="btn btn-primary" type="submit" disabled={yukleniyor} style={{ width: '100%', justifyContent: 'center', padding: '11px 16px', fontSize: 14, marginTop: 8 }}>
              {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
